import { render, staticRenderFns } from "./editSocialPlatform.vue?vue&type=template&id=553e21b8&lang=pug"
import script from "./editSocialPlatform.vue?vue&type=script&lang=js"
export * from "./editSocialPlatform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports